import { useEffect, useRef, useState } from "react";

export default function SubHeadlineSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="py-24 px-6"
      style={{ background: "#FDFCF9" }}
    >
      <div
        className="max-w-3xl mx-auto text-center"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(28px)",
          transition: "opacity 0.8s ease, transform 0.8s ease",
        }}
      >
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="h-px w-12" style={{ background: "#C9956F" }} />
          <span
            className="text-xs font-semibold tracking-widest uppercase"
            style={{ color: "#C9956F", fontFamily: "'Inter', sans-serif" }}
          >
            Your Growth Is Being Blocked
          </span>
          <div className="h-px w-12" style={{ background: "#C9956F" }} />
        </div>

        <h2
          className="text-3xl md:text-4xl font-bold mb-6 leading-tight"
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            color: "#1C1C1C",
            letterSpacing: "-0.01em",
          }}
        >
          Get a free 15-minute audit and find out exactly what&apos;s blocking
          your growth{" "}
          <em style={{ color: "#C9956F", fontStyle: "italic" }}>
            and how to fix it fast.
          </em>
        </h2>

        <p
          className="text-base md:text-lg leading-relaxed"
          style={{ color: "#6B6B6B", fontFamily: "'Inter', sans-serif" }}
        >
          Most med spas are sitting on untapped revenue. In just 15 minutes, I
          pinpoint the exact leaks in your marketing and hand you a concrete
          plan no guesswork, no fluff.
        </p>

      </div>
    </section>
  );
}
